import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "compliance-error-resolution" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "card border-warning" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_6 = { class: "d-flex align-items-start" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_9 = { class: "d-flex align-items-start" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = {
  key: 2,
  class: "mb-0"
}


export default {
  __name: 'BookingComplianceErrorPanel',
  props: {
	complianceError: { type: Object, default: null },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
        _createElementVNode("div", { class: "text-warning me-2" }, [
          _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-lg" })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", { class: "mb-1 fw-bold text-warning" }, " Buchungsregeln nicht eingehalten ")
        ])
      ], -1 /* CACHED */)),
      _createCommentVNode(" Compliance Violation Messages "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createCommentVNode(" Cool-down violation message "),
          (__props.complianceError?.coolDownViolation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-clock text-warning me-2 mt-1" }, null, -1 /* CACHED */)),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_7, [
                      _cache[0] || (_cache[0] = _createTextVNode(" Die vorgegebenen Pausezeiten wurden nicht eingehalten.", -1 /* CACHED */)),
                      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _cache[2] || (_cache[2] = _createTextVNode(" Um zwei aufeinanderfolgende Buchungen im selben Raum vorzunehmen, muss zwischen diesen eine Unterbrechung von mindestens ", -1 /* CACHED */)),
                      _createElementVNode("strong", null, _toDisplayString(__props.complianceError.coolDownInSeconds / 60) + " Minuten", 1 /* TEXT */),
                      _cache[3] || (_cache[3] = _createTextVNode(" liegen.", -1 /* CACHED */)),
                      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _cache[5] || (_cache[5] = _createTextVNode(" Alternativ können Sie den Raum durchgehend buchen oder mit einer der Buchungen in einen anderen Raum wechseln. ", -1 /* CACHED */))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Max booking violation message "),
          (__props.complianceError?.maxBookingViolation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-calendar-check text-warning me-2 mt-1" }, null, -1 /* CACHED */)),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_10, [
                      _cache[7] || (_cache[7] = _createTextVNode(" Die maximale Anzahl an erlaubten Buchungen pro Tag wurde überschritten. Pro Tag dürfen Sie maximal ", -1 /* CACHED */)),
                      _createElementVNode("strong", null, _toDisplayString(__props.complianceError.maxBookingPerDay) + " Buchungen", 1 /* TEXT */),
                      _cache[8] || (_cache[8] = _createTextVNode(" vornehmen. Sie können eine andere Buchung für denselben Tag stornieren, wenn Sie diese Buchung vornehmen möchten. ", -1 /* CACHED */))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Suspicious pattern message "),
          (__props.complianceError?.suspiciousPattern)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("div", { class: "d-flex align-items-start" }, [
                  _createElementVNode("i", { class: "fas fa-calendar-check text-warning me-2 mt-1" }),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", { class: "mb-0" }, " Ihre Buchungen in diesem Raum erwecken den Anschein, als ob Sie versuchen würden die geltenden Buchungsregeln zu Umgehen. Bitte stellen Sie sicher, dass Sie an einem Tag nicht mehrere kurze Buchungen im selben Raum tätigen oder lassen Sie längere Pausen zwischen Ihren Buchungen, damit andere Studierende den Raum zwischenzeitlich nutzen können. ")
                  ])
                ], -1 /* CACHED */)
              ]))]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}
}

}